import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { Router } from '@angular/router';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';
import * as _ from "lodash";

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants } from '../../constants/Constants';

//baseclasses
import { BaseGridComponent } from '../../baseclasses/BaseGrid.component';

@Component({
    selector: 'my-fsv-customer-grid',
    templateUrl: './CustomerGrid.component.html',
    providers: [{ provide: BaseGridComponent, useExisting: forwardRef(() => FSVCustomerGridComponent) }]
})
export class FSVCustomerGridComponent extends BaseGridComponent {
    records: ent.FullServiceCustomer[] = [];
    selectedRecords: ent.FullServiceCustomer[] = [];
    @Input() public showLinkToSelf: boolean;
    @Input() public showSelectionCheckbox: boolean;

    cols: any[];


    constructor(private authenticationService: serv.AuthenticationService, private domainDataService: serv.DomainDataService, private router: Router) {
        super();
    }


    ngOnInit(): void {

        this.loadColumns();
    }


    loadColumns() {
        
        this.cols = [];
        //if (this.showLinkToSelf){ this.cols.push({ field: 'LinkToSelf', header: 'Link To Self' });}  

        this.cols.push({ field: 'CustomerNumber', header: 'Customer #' });
        this.cols.push({ field: 'Name', header: 'Name' });
        this.cols.push({ field: 'ZQCustomerNumber', header: 'ZQ Customer #' });
        this.cols.push({ field: 'CustomerStreetAddress', header: 'Address' });
        this.cols.push({ field: 'CustomerCity', header: 'City' });
        this.cols.push({ field: 'CustomerStateProvince', header: 'State/Province' });
        this.cols.push({ field: 'CustomerPostalCode', header: 'Postal Code' });

    }
}